import React from 'react';
import {
  FiActivity,
  FiAlertCircle,
  FiCheckCircle,
  FiClock,
  FiStopCircle,
  FiXCircle,
} from 'react-icons/fi';

import IconWrapper from '../../../ui/IconWrapper';
import type { RunStatus } from '../../../../types/scheduledJobs';

/**
 * Mirrors the TaskMonitorPanel.tsx pattern (yellow clock for pending,
 * pulsing blue activity for running, green check for succeeded, red X
 * for failed, gray stop for cancelled).
 */
export const RunStatusIcon: React.FC<{ status: RunStatus | string; className?: string }> = ({
  status,
  className,
}) => {
  const base = 'h-4 w-4';
  const cls = className ? `${base} ${className}` : base;
  switch (status) {
    case 'pending':
      return <IconWrapper icon={FiClock} className={`${cls} text-yellow-500`} />;
    case 'running':
      return (
        <IconWrapper
          icon={FiActivity}
          className={`${cls} text-blue-500 animate-pulse`}
        />
      );
    case 'succeeded':
      return <IconWrapper icon={FiCheckCircle} className={`${cls} text-green-500`} />;
    case 'failed':
      return <IconWrapper icon={FiXCircle} className={`${cls} text-red-500`} />;
    case 'cancelled':
      return <IconWrapper icon={FiStopCircle} className={`${cls} text-gray-500`} />;
    default:
      return <IconWrapper icon={FiAlertCircle} className={`${cls} text-gray-400`} />;
  }
};

export const getRunStatusBadgeVariant = (
  status: RunStatus | string | null | undefined,
): 'default' | 'secondary' | 'destructive' | 'outline' => {
  switch (status) {
    case 'succeeded':
      return 'default';
    case 'running':
    case 'pending':
      return 'secondary';
    case 'failed':
      return 'destructive';
    default:
      return 'outline';
  }
};
